<template lang="pug">
  .comunication-preferences.xs-f-small.max-at-tweak
    .row
      h4.bold.mt-20.mb-10 Email
      .checkbox-wrap
        MrInputCheckbox(v-model="tips", label="Receive tips & tricks")
      .checkbox-wrap
        MrInputCheckbox(v-model="promotions", label="Receive special offers")
      .checkbox-wrap
        MrInputCheckbox(v-model="unsub", label="Unsubscribe from all")

    .row
      h4.bold.mt-20.mb-10 Text Messaging
      .checkbox-wrap
        MrInputCheckbox(v-model="receiveAllSMS" label="Receive text alerts")
      .checkbox-wrap
        MrInputCheckbox(v-model="unsubAllSMS" label="Unsubscribe from all")

</template>

<script>
  import { mapState, mapActions } from "vuex";
  import MrInputCheckbox from "../../mrInputCheckbox";
  export default {
    name: "ComunicationPreferences",
    components: {
      MrInputCheckbox
    },

    computed: {
      ...mapState('customer', ['marketingPreferences']),

      tips: {
        get() {
          return this.marketingPreferences.tips;
        },

        set(value) {
          this.$store.commit('customer/setEmailTips', value);
          this.updateEmailPreferences();
        }
      },

      promotions: {
        get() {
          return this.marketingPreferences.promotions;
        },

        set(value) {
          this.$store.commit('customer/setEmailPromotions', value);
          this.updateEmailPreferences();
        }
      },

      unsub: {
        get() {
          return this.marketingPreferences.unsub;
        },

        set(value) {
          this.unsubAllEmails(value);
        }
      },

      receiveAllSMS: {
        get() {
          return this.marketingPreferences.sms_opt_out === null ? false : !this.marketingPreferences.sms_opt_out;
        },

        set(val) {
          this.setSMSPreferences(!val);
        }

      },

      unsubAllSMS: {
        get() {
          return this.marketingPreferences.sms_opt_out === null ? false : this.marketingPreferences.sms_opt_out;
        },

        set(val) {
          this.setSMSPreferences(val);
        }
      },
    },

    methods: {
      ...mapActions('customer', [
        'updateEmailPreferences',
        'unsubAllEmails',
        'updateSmsPreferences'
      ]),

      setSMSPreferences(val) {
        //- first check if customer has mobile number on file
        if (!this.marketingPreferences.mobile_number || !this.marketingPreferences.mobile_number.length) {
          this.$root.scrollTo('#customerInfo');
          return this.$store.dispatch('notifyWarn', 'Not able to update SMS notifications, please check your mobile phone number. ', { root: true });
        }

        this.updateSmsPreferences(val);
      },

    }
   }
</script>

<style scoped lang="stylus">
  .comunication-preferences
    margin-bottom 1.5em

  .checkbox-wrap
    margin 0.7em 0

  .choice
    margin 0.5em 0

</style>